import { Button } from '@/components/ui/button';
import { useCart } from '@/hooks/use-cart';
import { useDictionary } from '@/lib/context/locale-provider';
import { useDeleteCartItemOptionsMutation } from '@/slice/cartApi';
import React from 'react';

function CartSelectDelete() {
  const dict = useDictionary();
  const { state, dispatch } = useCart();
  const [deleteCartItemOptions] = useDeleteCartItemOptionsMutation();

  const handleSelectDelete = async () => {
    if (state.selectedItems.length > 0) {
      await deleteCartItemOptions(state.selectedItems);
    }
  };

  return (
    <Button
      variant="outline"
      className="px-1 py-0.5 border border-solid border-[#999999] giftifan5 font-bold text-base"
      onClick={handleSelectDelete}
    >
      {dict!.active.selectedDelete}
    </Button>
  );
}

export default CartSelectDelete;
